import { RootState } from "@/store/redux/store";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PolylineRoadmap, { IPolylineRoadmap } from "./PolylineRoadmap";

const RenderRoadmapPolilines = () => {
    const { roadmaps, routeDirection } = useSelector((state: RootState) => state.mapScreen);
    const [coordinates, setCoordinates] = useState<IPolylineRoadmap[]>();

    useEffect(() => {

        const directions: (string | number)[] = [0, 1];

        // фильтрация для отображения на карте ( пока отображаем всегда все)
        // if (routeDirection && routeDirection.length > 0) {
        //     routeDirection.forEach((direction) => {
        //         if (direction === 'from') {
        //             directions.push(0);
        //         } else if (direction === 'to') {
        //             directions.push(1);
        //         }
        //     });
        // }

        const data = roadmaps.reduce((acc, roadmap) => {
            //if (directions.includes(Number(roadmap.route_direction))) {
            const dataC: { routeId: string | number; coordinates: number[][]; direction: any; type?: "ТРАМВАЙ" | "АВТОБУС" } = {
                routeId: roadmap ? roadmap.route_id : new Date().getTime().toString(),
                coordinates: roadmap.roadmapPoints.map((point) => [point.latitude, point.longitude]),
                direction: roadmap.route_direction,
                type: roadmap.veh_type ? roadmap.veh_type.toUpperCase() as "ТРАМВАЙ" | "АВТОБУС" : undefined
            }
            acc.push(dataC);
            //}
            return acc;
        }, []);
        setCoordinates(data);
    }, [roadmaps, routeDirection])

    const roadmapUniqIds = new Set<number>();

    return (
        <>
            {coordinates && coordinates.map((coordinate, index) => {
                const isRoadmapUniqId = !roadmapUniqIds.has(Number(coordinate.routeId));
                if (isRoadmapUniqId) roadmapUniqIds.add(Number(coordinate.routeId));
                // isRoadmapUniqId ? coordinate.routeId : Number(coordinate.routeId) * 10
                return <PolylineRoadmap key={index} roadmapInfo={coordinate} routeDirection={routeDirection} />
            })}
        </>
    )
}

export default RenderRoadmapPolilines;
